module.exports = __webpack_public_path__ + "static/media/logo GTS.35dd6d88.png";